const DEFAULTS =   {
  headings: ['h2'],
  wrapperClass: 'dynamic-subnav__wrapper',
};

export default class dynamicSubnav {

  constructor(el, options = DEFAULTS) {
    if (!el) return;
    this.el = el;
    this.articleEl = el.closest('main');
    this.articleHeadings = [];

    Object.assign(this.options = {}, DEFAULTS, options);

    this.init();
  }

  init() {
    this.collectHeadings();
    this.identifyHeadings();
    this.el.innerHTML = this.buildTable();
    this.el.classList.add(this.options.wrapperClass);
  }

  collectHeadings() {
    this.options.headings.forEach(selector => {
      this.articleHeadings = [...this.articleHeadings, ...this.articleEl.querySelectorAll(selector)];
    });
  }

  identifyHeadings() {
    this.articleHeadings.forEach(h => {
      // replace spaces with underscores, then remove special characters
      h.id = encodeURIComponent(h.textContent.replace(/\s/g, '_').replace(/[^\w\s]/gi, ''));
    });
  }

  buildTable() {
    return `
      <nav aria-label="Dynamic subnavigation">
        <ul class="dynamic-subnav__container">
          ${this.articleHeadings.map(link => this.createHeadingLink(link)).join('')}
        </ul>
      </nav>
    `;
  }

  createHeadingLink(headingEl) {
    return `<li class="dynamic-subnav__item cl-anchored-subnav-section"><a href="#${headingEl.id}" class="cl-anchored-subnav-section-link">${headingEl.innerHTML}</a></li>`;
  }

}
